import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/internal/Observable';
import {filter, map, share} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

import {Merchant, RewardTiers} from '../models/restaurant.model';
import { CartStore } from '../stores/cart.store';
import {dataToMerchantInfo} from '../dto/merchant.dto';

@Injectable()
export class MerchantService {

  constructor(private http: HttpClient,
   private cartStore: CartStore) {
  }

  public getMerchants(): Observable<Merchant[]> {
    const apiURL = `${environment.apiUrl}merchants`;
    return this.http.get(apiURL)
      .pipe(
        map((response: any) => response
          .map(merchant =>
            new Merchant(
              merchant.merchant_id,
              merchant.business_name,
              merchant.merchant_email,
              merchant.merchant_header_title,
              merchant.merchant_header_text)
          )
        ),
        share(),
      );
  }

  public getMerchantData(merchantId: string): Observable<Merchant> {
    const apiURL = environment.apiUrl;
    return this.http.get(`${apiURL}merchants/${merchantId}/info`)
      .pipe(
        filter(Boolean),
        map((response: any) => dataToMerchantInfo(response, merchantId)),
        share(),
      );
  }

  public getMerchantByVanityLink(vanityLink: string): Observable<Merchant> {
    const apiURL = environment.apiUrl;
    return this.http.get(`${apiURL}${vanityLink}/info`)
      .pipe(
        filter(Boolean),
        map((response: any) => new Merchant(response.merchant_id, response.merchant_name, response.merchant_email, response.merchant_header_title, response.merchant_header_text)),
        share(),
      );
  }

  public getLoyaltyProgram(merchantId: string): Observable<RewardTiers[]> {
    const apiURL = environment.apiUrl;
    return this.http.get(`${apiURL}merchants/${merchantId}/loyalty-program`).pipe(
      filter(Boolean),
      map((response: any) =>
           response.reward_tiers.map((reward_tier:any) => new RewardTiers(reward_tier.id, reward_tier.name, reward_tier.points, reward_tier.created_at, reward_tier.definition)
        )
      ),
      share()
    );
  }
}
